import { render, staticRenderFns } from "./filedetail-add-single.vue?vue&type=template&id=37743cf8&scoped=true&"
import script from "./filedetail-add-single.vue?vue&type=script&lang=js&"
export * from "./filedetail-add-single.vue?vue&type=script&lang=js&"
import style0 from "./filedetail-add-single.vue?vue&type=style&index=0&id=37743cf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37743cf8",
  null
  
)

export default component.exports